// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"8e72e9e8","154":"cbafe5df","163":"18fca4a2","496":"3b62f828","599":"d45e54ac","600":"56120fbe","707":"13c7aa03","952":"8a467042"}[chunkId] + ".chunk.js";
};